export class IContact {
    id: string;
    name: string;
    contactTitle: string;
    address: String;
    address2: String;
    city: string;
    state: String;
    zipCode: string;
    country: string;
    phoneNumber: string;
    phoneNumber2: string;
    phoneNumber3: string;
    cellNumber: string;
    faxNumber: string;
    email: string;
    notes: string;
    isDefault: boolean;
    constructor(){
    }
}